
import Header from '../../components/feature/Header';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-white text-gray-800 py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/bc3779cc25de64a127a5321b3d93172b.jpg')`
          }}
        ></div>
        <div className="relative container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            {/* 移除這段文字 */}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">主要服務項目</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-government-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">公共工程</h3>
              <p className="text-gray-600 text-sm">承攬各類政府公共建設工程，包括學校、道路、橋樑等基礎設施建設</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">建築工程</h3>
              <p className="text-gray-600 text-sm">提供民間住宅、商業建築等各類建築工程服務，品質優良</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300">
              <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hammer-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">土木工程</h3>
              <p className="text-gray-600 text-sm">專業土木工程施工，包括基礎工程、結構工程等各項土木建設</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">專業服務</h3>
              <p className="text-gray-600 text-sm">區域排水、環境改善、室內裝修、災害修復等專業工程服務</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "Pacifico, serif" }}>和明營造有限公司</h3>
            <p className="text-gray-400 mb-4">負責人：葉芷玲 | 統一編號：13144873</p>
            <p className="text-gray-400 text-sm">
              © 2024 和明營造有限公司. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-blue-400 hover:text-blue-300 ml-1 cursor-pointer">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
